import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Text, InputSearch, SelectBox, Card, Skeleton } from '@mercai/clever'

import type { SelectSupplierFormProps } from './select-supplier-form.type'

import styles from './select-supplier-form.module.css'
import { useSupplierList } from '@/services'

export const SelectSupplierForm = ({
  onChangeValues,
  values,
  errors,
}: SelectSupplierFormProps) => {
  const { t } = useTranslation('componentSelectSupplierForm')

  const [search, setSearch] = useState('')

  const { data, isLoading } = useSupplierList({
    params: {
      currentPage: 1,
      search,
    },
  })

  const showSuppliers = !isLoading && data?.data?.results

  return (
    <div className={styles.core}>
      <InputSearch
        className={styles.input}
        value={search}
        onChange={setSearch}
        translations={{
          inputPlaceholder: t('inputSearchPlaceholder'),
        }}
      />

      {isLoading &&
        [0, 1, 2, 3, 4].map((number) => (
          <Card className={styles['loading-items']} key={number}>
            <Skeleton
              width="1rem"
              height="1rem"
              className={styles['loading-items-circle']}
            />

            <div className={styles['loading-items-content']}>
              <Skeleton width="100%" height="1.2rem" />

              <Skeleton width="100%" height="1rem" />
            </div>
          </Card>
        ))}

      {showSuppliers &&
        values &&
        !data?.data?.results?.find((item) => item?.uuid === values?.uuid) && (
          <SelectBox
            title={`${values?.name}`}
            onChange={() => {}}
            value={true}
            key={values?.uuid}
          >{`${values?.email || '-'}`}</SelectBox>
        )}

      {showSuppliers &&
        data?.data?.results?.map((supplier) => (
          <SelectBox
            title={`${supplier?.name}`}
            onChange={() => onChangeValues(supplier)}
            value={values?.uuid === supplier?.uuid}
            key={supplier?.uuid}
            hasError={!!errors?.supplier}
          >
            {`${supplier?.email || '-'}`}
          </SelectBox>
        ))}

      {!isLoading && data?.data?.results?.length === 0 && !values && (
        <Text>{t('emptyLabel')}</Text>
      )}
    </div>
  )
}
